import { render, staticRenderFns } from "./CartSubTotal.vue?vue&type=template&id=1b6c9bf1&"
import script from "./CartSubTotal.vue?vue&type=script&lang=js&"
export * from "./CartSubTotal.vue?vue&type=script&lang=js&"
import style0 from "./CartSubTotal.vue?vue&type=style&index=0&id=1b6c9bf1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports